import { IconButton } from "@mui/material";
import React, { useState } from "react";

import { AiOutlineHome, AiOutlineDeploymentUnit } from "react-icons/ai";

function DetailAbout() {
    const [activeTab, setActiveTab] = useState("tab1");

    const handleDetailProfile = () => {
        setActiveTab("tab1");
    };
    const handleDetailStruktur = () => {
        setActiveTab("tab2");
    };

    return (
        <>
            <section className="section-header-profil">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-2 d-flex justify-content-center">
                            <div className="circle-button mx-2">
                                <IconButton
                                    id="label-icon"
                                    size="large"
                                    aria-label="circle-button-icon"
                                    className={
                                        activeTab === "tab1 " ? "active" : ""
                                    }
                                    onClick={handleDetailProfile}
                                >
                                    <AiOutlineHome size={35} />
                                </IconButton>
                                <div className="label-button text-center my-2">
                                    <p>Profile </p>
                                </div>
                            </div>
                            <div className="circle-button mx-3">
                                <IconButton
                                    id="label-icon"
                                    size="large"
                                    aria-label="circle-button-icon"
                                    className={
                                        activeTab === "tab2" ? "active" : ""
                                    }
                                    onClick={handleDetailStruktur}
                                >
                                    <AiOutlineDeploymentUnit size={35} />
                                </IconButton>
                                <div className="label-button text-center my-2">
                                    <p>struktur </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {activeTab === "tab1" ? (
                <>
                    <section className="section-profile" id="profile">
                        <div className="container">
                            <div className="row ">
                                <div className="col-lg-10 offset-lg-1 align-self-center">
                                    <h1 className="text-center">
                                        Manggala Pustaka
                                    </h1>
                                    <p>
                                        Taman Baca Masyarakat Manggala pustaka
                                        merupakan satu-satu nya Taman baca yang
                                        ada di desa Simo, Tepatnya di dukuh
                                        Manggal Rt 17/rw 06. Kecamatan Simo,
                                        Kabupaten Boyolali. Perpustakaan
                                        Manggala Pustaka merupakan gagasan dari
                                        masyarakat di dukuh Manggal terutama
                                        para pemuda-pemudi desa. TBM sendiri
                                        bergerak dibidang khususnya anak-anak.
                                        Adapun kegiatan dri TBM antara lain
                                        seperti kelas mewarnai, kelas mengaji,
                                        kelas memanah kelas kesenian, serta
                                        kelas darurat yang di adakan pda saat
                                        anak-anak sekolah online, tak hanya
                                        dibagian anak saja kegiatan yang
                                        mengarah ke masyarakat seperti
                                        pengecekan kesehatan, diskusi tentang
                                        pertanian modern serta kegiatan positif
                                        lainnya guna untuk meningkatkan
                                        perekonomian dan pemberdayaan masyarakat
                                    </p>
                                    <p>Visi dan Misi Kami</p>

                                    <p>
                                        Menjadi perpustakaan yang membudayakan
                                        masyarakat gemar membaca serta
                                        memperkaya wawasan masyarakat melalui
                                        buku.
                                    </p>
                                    <ul>
                                        <li>Menyediakan buku-buku bermutu</li>
                                        <li>
                                            Sebagai wadah dari ide-ide kreatif
                                            dari masyarakat
                                        </li>
                                        <li>
                                            Merealisasikan ide-ide kreatif dari
                                            masyarakat
                                        </li>
                                        <li>
                                            Menjadikan masyarakat yang
                                            berkualitas, dari segi pendidikan,
                                            budaya dan ekonomi
                                        </li>
                                        <li>
                                            Menjadi forum silaturahmi yang
                                            menjembatani terlaksananya
                                            kegiatan-kegiatan positif yang
                                            sifatnya mengembangkan diri
                                        </li>
                                    </ul>
                                    <p>
                                        Perpustakaan “Manggala Pustaka” ini
                                        menggunakan lahan kosong salah satu
                                        rumah warga yang disewakan. Akan tetapi,
                                        agar dapat berfungsi sebagaimana
                                        mestinya sebuah perpustakaan tentunya
                                        membutuhkan bangunan serta sarana dan
                                        prasarana guna kelengkapan sebuah
                                        perpustakaan.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            ) : (
                <>
                    <section className="section-struktur" id="struktur">
                        <div className="container">
                            <div className="row ">
                                <div className="col-lg-10 offset-lg-1 align-self-center">
                                    <h1 className="text-center">
                                        Struktur Organisasi
                                    </h1>
                                    <p>
                                        Lorem ipsum dolor sit amet consectetur
                                        adipisicing elit. Quae velit facere
                                        beatae cum doloribus, enim quas a quam?
                                        Hic excepturi aperiam odio illum
                                        temporibus nam? Impedit nemo hic magnam
                                        quaerat! Lorem ipsum dolor sit amet
                                        consectetur adipisicing elit. Quam alias
                                        ipsam illo odio at consequatur
                                        voluptates labore similique, adipisci
                                        dolorem cum perspiciatis expedita nulla
                                        veniam, iure sequi est, rem optio. Lorem
                                        ipsum dolor sit amet consectetur
                                        adipisicing elit. Excepturi veritatis ad
                                        commodi quam doloribus quasi harum
                                        labore laudantium nihil repellat eum id
                                        sunt in, assumenda consequatur soluta
                                        deleniti optio deserunt?
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}
        </>
    );
}

export default DetailAbout;
